import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DeviceDetectorService } from "ngx-device-detector";

@Component({
  selector: 'app-register-call-center-dialog',
  templateUrl: './register-call-center-dialog.component.html',
  styleUrls: ['./register-call-center-dialog.component.css']
})
export class RegisterCallCenterDialogComponent implements OnInit {
  @Input() data: any;
  isShowCallCenterNumber: boolean = false;
  isMobileDevice: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit() {
    this.isMobileDevice = this.deviceService.isMobile()
  }

  showCallCenterNumber() {
    this.isShowCallCenterNumber = true;
  }

  onCopySuccess() {
    this.toastr.success("Nomor Telepon berhasil Disalin.", '', {
      timeOut: 3000
    });
  }

}
